import { render } from "./LegacyView.vue?vue&type=template&id=0170e7c4"
import script from "./LegacyView.vue?vue&type=script&lang=js"
export * from "./LegacyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__